export function getInternalAssetImage(fileName: string) {
  if (process?.env?.JEST_WORKER_ID) {
    return '/mock/' + fileName;
  }
  const path = require(`../../../../asset/images/${fileName}`);
  return path?.default || path;
}
